import { Component, Inject, EventEmitter, Output, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { IState } from '../../../../app-pwp/src/app/core/interfaces/IState';
import { application } from '../../../../app-pwp/src/app/core/globals';
import { IGlobal } from '../../../../app-pwp/src/app/core/interfaces/IGlobal';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
  public application: IGlobal = application;

  @Output() stateChanged = new EventEmitter<IState>();
  @Input() isSessionLost: boolean = false;

  public version: string = '0.0.0.0';
  public user: string = '';
  private isAdmin: boolean = false;

  public isExpanded = false;

  http: HttpClient;
  baseUrl: string;

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.http = http;
    this.baseUrl = baseUrl;

    this.version = application.version;
    this.user = application.user;
    this.isAdmin = application.isAdmin;
  };

  public collapse() {
    this.isExpanded = false;
  }

  public toggle() {
    this.isExpanded = !this.isExpanded;
  }

  public doLogout() {
    this.http
      .get<IState>(this.baseUrl + 'api/pwp/security/logout')
      .subscribe(result => {
        this.stateChanged.emit(result);
        application.technicalRoleNames = null;
      }, error => console.error(error));
  }
}
